/* eslint-disable no-nested-ternary */
import Leaderboard from '@/components/conversation-insights/leaderboard'
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet'
import { cn } from '@/lib/utils'
import React from 'react'
import ZipInsights from '@/components/conversation-insights/zip-insights';
import ToggleExpandIcon from '../../public/icons/new-dashboard/arrow-expand-04.svg';
import ViewDashboardIcon from "../../public/icons/new-dashboard/file-eye-02.svg";
import CopyIcon from '../../public/icons/new-dashboard/copy-left.svg';
import EmptyZipInsights from '../../public/icons/new-dashboard/empty-zip-insights.svg'

type Props = {
    workspaceId: number;
    organisationId: number;
    loadingKeyInsights: boolean;
    zipInsights: any[];
    agents: any[];
    previousAppliedFilters: any;
    openZipInsights: boolean;
    handleLeaderboardUserClick: Function;
    handleLeaderboardUserRemove: Function;
    handleCopyZipInsights: Function;
    openLeaderboard: boolean;
    setOpenLeaderboard: Function;
    setOpenZipInsights: Function;
    authToken?: string;
}

const LeaderboardSheet = ({
    workspaceId,
    organisationId,
    loadingKeyInsights,
    zipInsights,
    agents,
    previousAppliedFilters,
    openZipInsights,
    handleLeaderboardUserClick,
    handleLeaderboardUserRemove,
    handleCopyZipInsights,
    openLeaderboard,
    setOpenLeaderboard,
    setOpenZipInsights,
    authToken,
}: Props) => {
  return (
    <Sheet >
        <SheetTrigger asChild>
        <div className='w-8 h-8 p-2 border border-[#E4E4E7] rounded-md cursor-pointer'><ViewDashboardIcon /></div>
        </SheetTrigger>
        <SheetContent className="p-0 h-full">
          <div className={cn("flex flex-col h-full transition-all duration-300")}>

            <section className="px-4 pt-5 max-h-[50%]">
              <div className="flex items-center justify-between">
                <h2 className="font-bold break-words">Zip Insights</h2>
                <div className="flex items-center gap-2 mr-4">
                  <button
                    type="button"
                    className="hover:bg-gray-100 h-6 w-6 p-1 flex items-center justify-center rounded-lg"
                    onClick={() => handleCopyZipInsights()}
                  >
                    <CopyIcon />
                  </button>
                  <button
                    type="button"
                    className="hover:bg-gray-100 h-6 w-6 p-1 flex items-center justify-center rounded-lg"
                    onClick={() => setOpenZipInsights((prev) => !prev)}
                  >
                    <ToggleExpandIcon />
                  </button>
                </div>
              </div>

              <p className="mt-1 px-4 text-sm text-paragraph">
                AI-powered insights from your sales activity
              </p>

              {openZipInsights ? (
                    loadingKeyInsights ? (
                      <div className="my-4 h-full w-full text-center">Loading...</div>
                    ) : zipInsights?.length > 0 ? (
                      <ZipInsights zipInsights={zipInsights} agents={agents} />
                    ) : (
                      <div className="h-72 flex flex-col items-center justify-center">
                        <EmptyZipInsights />
                        <p className="text-center max-w-64 text-sm text-paragraph">
                          Looks like there are no insights available at the moment.
                        </p>
                      </div>
                    )
                  ) : (
                    <div />
                  )}
            </section>

            <section className="px-4 pt-4 flex-1 overflow-y-auto border-t border-gray-200 bg-white">
              <div className="flex items-center justify-between">
                <p className="font-bold break-words">Leaderboard</p>
                {/* <button
                  type="button"
                  className="hover:bg-gray-100 h-6 w-6 p-1 flex items-center justify-center rounded-lg mr-4"
                  onClick={() => setOpenLeaderboard((prev) => !prev)}
                >
                  <ToggleExpandIcon />
                </button> */}
              </div>

              <p className="mt-1 px-4 text-sm text-paragraph">
                Sort your team by the key metrics
              </p>

              {openLeaderboard && (
                <Leaderboard
                workspaceId={workspaceId}
                organisationId={organisationId}
                insightsFilters={previousAppliedFilters}
                openZipInsights={openZipInsights}
                handleLeaderboardUserClick={handleLeaderboardUserClick}
                handleLeaderboardUserRemove={handleLeaderboardUserRemove}
                authToken={authToken}
              />
              )}
              
            </section>
          </div>
        </SheetContent>
    </Sheet>
  )
}

export default LeaderboardSheet